import axios from "axios";
import env from "@/env";
import router from "@/router";
import {notifyError} from "@/components/composables/messages";
import store from "@/state/store";

const http = axios.create({
    baseURL: env.api,
});

// Função que retorna o token atualizado
function getToken() {
    return localStorage.getItem('token');
}

// Adicionando um interceptador de requisição ao Axios
http.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Adicionando um interceptador de resposta para lidar com erros
http.interceptors.response.use(
    (response) => {
        // Se a resposta for bem-sucedida, simplesmente a retorne
        return response;
    },
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 402)) {
            store.commit('api/endProcessing');
            notifyError('Não autorizado!');
            localStorage.removeItem('token');
            if (router.name !== 'login') router.push('/login');
        } else {
            return Promise.reject(error);
        }
    }
);

export default http;
